import { c as _c } from "react/compiler-runtime";
import type { Decisions } from '../types';
import { useCacheKey } from './useCacheKey';
import { useOptimizely } from './useOptimizely';
export function useDecisions(): Decisions;
export function useDecisions<F extends keyof Decisions>(flag: F): Decisions[F];
export function useDecisions(flag) {
  const $ = _c(3);
  const {
    context
  } = useOptimizely();
  const {
    cookies
  } = useCacheKey();
  let t0;
  if ($[0] !== context || $[1] !== cookies) {
    t0 = new Proxy(JSON.parse(cookies.get("x-petm-decisions") ?? "{}"), {
      get(target, prop, receiver) {
        if (typeof prop !== "string") {
          return;
        }
        context?.decide(prop);
        const value = Reflect.get(target, prop, receiver);
        if (!value) {
          return false;
        }
        return value;
      }
    });
    $[0] = context;
    $[1] = cookies;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const proxy = t0;
  if (!flag) {
    return proxy;
  }
  return proxy[flag];
}